import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('maintenance-request-list/index', {params});
    },
    getCustomer(params) {
        return Service().get('maintenance-request-list/get-customer', {params});
    },
    show(id) {
        return Service().get('maintenance-request-list/show/'+id);
    },
    create(params) {
        return Service().post('maintenance-request-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('maintenance-request-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('maintenance-request-list/delete/'+id);
    },
}